import { CModal } from "components/widget/CModal"
import { SvgTick } from "icons/SvgTick"
import { LayoutStore } from "store/layout-store"
import { ModalTradesSettingsProps } from "types/layout-types"
import { methodHandelChangeFields } from "utils/layout-utils"


export const ModalTradesSettings = ({ visible, setVisible }: ModalTradesSettingsProps) => {
    const { userId, currentUserFields, setCurrentUserFields } = LayoutStore()

    const handelChangeFields = (selectItem: any) => {
        methodHandelChangeFields(userId, selectItem, setCurrentUserFields)
    }

    return (
        <>
            <CModal visible={visible} setVisible={setVisible} width="1000px" uId="ModalTradesSettings">
                <div className="w-full flex flex-wrap md:p-3 p-1">
                    {new Array(5).fill("").map((itemCont: any, indexCont: number) =>
                        <div key={indexCont} className="lg:w-[20%] w-[50%] h-fit flex flex-col">
                            {currentUserFields?.map((item: any, index: number) =>
                                <>
                                    {item.category ==  indexCont+1 &&
                                        <div key={index} className=" w-full p-1">
                                            <button onClick={() => handelChangeFields(item)} className="w-full h-[40px] rounded bg-trade-25 flex items-center justify-between px-1">
                                                <span className="text-xs text-white">{item.title}</span>
                                                {item.isActive == true ?
                                                    <div className="w-[15px] h-[15px] flex items-center justify-center border border-trade-75 bg-trade-75 rounded">
                                                        <SvgTick className="w-[15px] stroke-trade-50" />
                                                    </div>
                                                    :
                                                    <div className="w-[15px] h-[15px] flex items-center justify-center border border-trade-75 bg-transparent rounded"></div>
                                                }
                                            </button>
                                        </div>
                                    }
                                </>
                            )}
                        </div>
                    )}

                </div>
                <div className="w-full flex items-center mb-4 md:px-3 px-1 ">
                    <button onClick={() => { setVisible(false) }} className="w-full h-[40px] rounded-md bg-transparent border border-trade-75 text-trade-75 flex items-center justify-center ">بستن</button>
                </div>
            </CModal>
        </>
    )
}